import angular from 'angular';
import existingAddressInput from './existingAddressInput';

export default angular
  .module('components.existingAddressInput', [])
  .component('existingAddressInput', existingAddressInput).name;
